module.exports = __webpack_public_path__ + "img/jokasport.48733c5f.png";